// @flow

import React, { Component, PropTypes } from 'react'
import { Router } from 'react-router'
import { Provider, connect } from 'react-redux'
import {IntlProvider, addLocaleData} from 'react-intl'
import messages from '../lang'
import en from 'react-intl/locale-data/en';
import zh from 'react-intl/locale-data/zh';
import th from 'react-intl/locale-data/th';
import pl from 'react-intl/locale-data/pl';
import ja from 'react-intl/locale-data/ja';

import de from 'react-intl/locale-data/de';
import tr from 'react-intl/locale-data/tr';

import id from 'react-intl/locale-data/id';
import es from 'react-intl/locale-data/es';

import ro from 'react-intl/locale-data/ro';

import type {State, Locale, Action} from '../types'
import type { Store as ReduxStore } from 'redux'

import moment from 'moment'
import {dateRangeMap} from '../components/DayWeekMonthButtonGroupSelect'

addLocaleData([...en, ...zh, ...th, ...pl, ...ja, ...de, ...tr, ...es, ...id, ...ro]);
const SUPPORTED_LANGUAGE = ['en', 'zh-cn','zh-tw', 'ja', 'ro']

function mapStateToProps(state: State, ownProps) {

  const locale: Locale = state.locale
  return {
    locale
  }
}

const mapDispatchToProps = {


}


class AppContainer extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    routes: PropTypes.array.isRequired,
    store: PropTypes.object.isRequired
  }

  props:{
    locale: Locale,
    history: any,
    routes: Array<any>,
    store: ReduxStore<State, Action>

  }

  componentWillMount(){
    moment.updateLocale('en', {longDateFormat:{l:'DD/MM/YYYY', ll:'DD MMM YYYY'}})
    moment.locale(this.props.locale)

    Object.keys(dateRangeMap).forEach((k)=>{
      dateRangeMap[k].startDate.locale(this.props.locale)
      dateRangeMap[k].endDate.locale(this.props.locale)
    })
  }

  componentWillReceiveProps(nextProps){
    if(this.props.locale !== nextProps.locale) {
      moment.locale(nextProps.locale)
      Object.keys(dateRangeMap).forEach((k)=>{
        dateRangeMap[k].startDate.locale(nextProps.locale)
        dateRangeMap[k].endDate.locale(nextProps.locale)
      })
    }
  }

  render () {

    const { history, routes, store, locale } = this.props

    return (
      <Provider store={store}>
          <IntlProvider locale={locale} key={locale}
                        defaultLocale="en"
                        messages={messages[locale]}>
            <div style={{ height: '100%' }}>
              <Router history={history} children={routes} />
            </div>
          </IntlProvider>
      </Provider>

    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer)



// WEBPACK FOOTER //
// ./src/containers/AppContainer.js